import classNames from 'classnames/bind';
import styles from './FaqQuestions.module.scss';
import { Heading, List, ChevronRight } from '@/components';
import Link from 'next/link';
let cx = classNames.bind(styles);

export function FaqQuestions({ title, questions, query, pagePath, relatedQuestions = false, basePath }) {
  const hasQuestions = questions.length > 0;

	return (
		<>
			{hasQuestions && (
				<div className={cx([relatedQuestions && 'related-questions'])}>
					<Heading level={relatedQuestions ? 'h3' : 'h2'} className={cx([relatedQuestions ? 'is-style-heading-body' : 'is-style-heading-lead-body'])}>
						{title}
					</Heading>
					{query && <p className={cx(['is-font-size-sm'])}>{`${questions.length} results for "${query}"`}</p>}
					<List elem="ul" listStyle="none" className={cx(['faqs-questions-list'])}>
						{questions.map((question) => (
							<li key={question.id}>
								<Link className={cx(['question-link'])} href={relatedQuestions ? `${pagePath}/${question.category.id}/${question.id}` : `${pagePath}/${question.id}`}>
									<div>{question.text}</div>
									<div>
										<ChevronRight />
									</div>
								</Link>
							</li>
						))}
					</List>
				</div>
			)}
			{!hasQuestions && !relatedQuestions && (
				<p>
					No questions found. Go back to the <Link href={basePath}>FAQ homepage</Link>.
				</p>
			)}
		</>
	);
}
